import { languageOptions } from '@/constants';

export const findLanguage = (code: string) => {
  return languageOptions.find((item) => item.value.toLowerCase() === code.toLowerCase());
};
